var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardCard',{staticClass:"mr-5",attrs:{"cardIcon":{name: 'briefcase', bg: 'bg-gray-700', textBg: 'text-gray-700'},"cardTitle":_vm.title,"notificationCount":_vm.count}})
}
var staticRenderFns = []

export { render, staticRenderFns }